import { render, staticRenderFns } from "./r-daily-bonus-page.vue?vue&type=template&id=04cb51aa"
import script from "./r-daily-bonus-page.vue?vue&type=script&lang=js"
export * from "./r-daily-bonus-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04cb51aa')) {
      api.createRecord('04cb51aa', component.options)
    } else {
      api.reload('04cb51aa', component.options)
    }
    module.hot.accept("./r-daily-bonus-page.vue?vue&type=template&id=04cb51aa", function () {
      api.rerender('04cb51aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/daily-bonus/r-daily-bonus-page.vue"
export default component.exports